import { render, staticRenderFns } from "./AddNewDelivery.vue?vue&type=template&id=93774aac&"
import script from "./AddNewDelivery.vue?vue&type=script&lang=js&"
export * from "./AddNewDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports